import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ColorInput as CommonColorInput } from '@blueprintnyc/bpnyc-common-admin';
import './ColorInput.scss';

const TRANSPARENT = 'transparent';

const presetColors = [
	'#FFFFFF',
	'#D9D9D9',
	'#969696',
	'#000000',
	'#D9534F',
	'#E53F6F',
	'#9031AA',
	'#3F51B5',
	'#62B1F6',
	'#5CB85C',
	'#F0AD4E',
	'#FCEC60',
	// remaining default colors not incuded default 12 when custom theme is available
	// used to check whether palette should be custom or default
	'#613CB0',
	'#235696',
	'#4994EC',
	'#97C15C',
	'#D0DC59',
	'#F6C344',
];

// bpnyc-common-admin's ColorInput shows this palette, in this order, when given 12 or fewer swatches
const commonDefaultSwatches = [
	'#FFFFFF',
	'#D9D9D9',
	'#969696',
	'#000000',
	'#D9534F',
	'#E53F6F',
	'#9031AA',
	'#613CB0',
	'#3F51B5',
	'#235696',
	'#4994EC',
	'#62B1F6',
	'#5CB85C',
	'#97C15C',
	'#D0DC59',
	'#FCEC60',
	'#F6C344',
	'#F0AD4E',
];

const withTransparentSwatch = swatches => [
	...(swatches.length > 12 ? swatches : commonDefaultSwatches),
	TRANSPARENT,
];

const themeElements = [
	'brandPrimary',
	'brandSecondary',
	'navBg',
	'navIconAndText',
	'headerBg',
	'headerText',
	'btnPrimaryBg',
	'btnInfoBg',
	'btnSuccessBg',
];

const formatColor = colorStr => {
	const hex = colorStr.toUpperCase();
	return hex.length <= 7 ? (hex + hex.split('#')[1]).substring(0, 7) : hex;
};

const themeReducer = theme => [
	...presetColors.slice(0, 12),
	...Object.entries(theme).reduce((swatches, [key, val]) => {
		if (themeElements.includes(key)) {
			const hexCode = formatColor(val);
			if (!swatches.includes(hexCode) && !presetColors.includes(hexCode)) swatches.push(hexCode);
		}
		return swatches;
	}, []),
];

const ColorInput = props => {
	const {
		currentEvent,
		color,
		value,
		swatchColors: parentSwatchColors,
		onChange,
		onSubmit,
		autosave,
		defaultColor,
		allowTransparent,
	} = props;

	const theme = currentEvent.theme;
	const themeSwatches = parentSwatchColors ? parentSwatchColors : themeReducer(theme);
	const swatchColors = allowTransparent ? withTransparentSwatch(themeSwatches) : themeSwatches;
	const [hexCode, setHexCode] = useState('');
	const isTransparent = hexCode === TRANSPARENT;

	useEffect(() => {
		setHexCode(value ? value : color);
	}, [value, color]);

	const handleSubmit = hex => {
		if (onSubmit) {
			!hex && defaultColor ? onSubmit(defaultColor) : onSubmit(hex);
		}
	};

	const handleChange = color => {
		if (onChange) {
			onChange(color);
		}
	};

	const colorProps = {
		color: isTransparent ? TRANSPARENT : hexCode ? hexCode.toUpperCase() : '',
		swatchColors,
		onChange: handleChange,
		onSubmit: handleSubmit,
		autosave,
	};

	return (
		<div className={`color-input-container${isTransparent ? ' is-transparent' : ''}`}>
			<CommonColorInput {...colorProps} />
		</div>
	);
};

const msp = ({ events }) => ({
	currentEvent: events.currentEvent,
});

export default connect(msp)(ColorInput);
